export const SET_SURVEYS = 'SET_SURVEYS'
export const DELETE_SURVEY = 'DELETE_SURVEY'
export const SET_IS_SHOW_SURVEYS_MODAL = 'SET_IS_SHOW_SURVEYS_MODAL'
export const SET_IS_SHOW_SURVEYS_TO_LOCALSTORAGE = 'SET_IS_SHOW_SURVEYS_TO_LOCALSTORAGE'



// WEBPACK FOOTER //
// ./src/store/modules/surveys/mutation-types.js